<template>
<div id="contentWrap">
  <div v-show="isIndexShowBanner" class="slider_container">
    <div>
      <img src="../../../assets/images/Saipa_banner1_Far.png" alt="pure css3 slider" />
    </div>
    <div>
      <img src="../../../assets/images/Saipa_banner2_Far.png" alt="pure css3 slider" />
    </div>
    <div>
      <img src="../../../assets/images/Saipa_banner3_Far.png" alt="pure css3 slider" />
    </div>
  </div>
  <div class="content right">
    <CustomAside></CustomAside>
    <router-view></router-view>
  </div>
</div>
</template>

<script>
/*jshint esversion: 6 */
import CustomAside from './Aside';
export default {
  name: 'private',
  components: {
    CustomAside
  },
  data() {
    return {
      isIndexShowBanner: false,
    };
  },
  mounted() {
    if (this.$route.path.substr(0, 11) === '/Main/Index') {
      this.isIndexShowBanner = true;
    }
  },
  watch: {
    $route() {
      if (this.$route.path.substr(0, 11) === '/Main/Index') {
        this.isIndexShowBanner = true;
      } else {
        this.isIndexShowBanner = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// Layout.vue?99ed82c8